angular.module('routes.simulation.SimulationController', [
  'stack'
])

/**
 * The SimulationController manages view logic rendered to the
 * simulation.html template for the /simulation view.
 *
 * @class SimulationController
 * @constructor
 * @module routes.simulation.SimulationController
 */
.controller('SimulationController', [
  '$rootScope',
  '$scope',
  '$state',
  '$location',
  '$window',
  'constants',
  'ModelsService',
  'SimulationService',
  'ThemesService',
  function (
    $rootScope,
    $scope,
    $state,
    $location,
    $window,
    constants,
    ModelsService,
    SimulationService,
    ThemesService
  ) {
    'use strict';

    $scope.constants = null;

    $scope.state = $state;

    $scope.simulation = {
      list: [],
      current: null
    };

    $scope.states = {
      list: [],
      current: null
    };

    $scope.widgets = {
      list: [],
      all: [],
      current: null
    };

    $scope.updateList = function () {
      defineStateList();
      // defineWidgetList();
    };

    /**
     * Method copies resolved constants into the controller
     * namespace during the initalization process.
     *
     * @private
     */
    function defineConstants() {
      $scope.constants = constants;
    }

    /**
     * Method sets simulation data from Model
     *
     * @private
     */
    function defineCaseList() {
      $scope.simulation.list = SimulationService.get();
    }

    /**
     * Defines the current simulation
     */
    function defineCurrentCase() {
      if ($state.params.caseId) {
        $scope.simulation.current = SimulationService.get($state.params.caseId);
        // checkPublished($scope.simulation.current);
      } else {
        $scope.simulation.current = null;
      }
    }

    /**
     * Defines the current theme
     */
    function defineTheme() {
      $scope.theme = {};
      ThemesService
        .getThemeConfig($scope.simulation.current.content.theme)
        .then(function (theme) {
          $scope.theme = theme.data;
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    /**
     * Method sets state data from Model
     *
     * @private
     */
    function defineStateList() {
      var stateList = [];

      if ($scope.simulation.current) {
        stateList = _.filter($scope.simulation.current.relatives, function (obj) {
          return _.includes(obj.classes, 'states');
        });
      }

      $scope.states.list = stateList;

      if ($state.params.stateId) {
        if (SimulationService.checkForDisabled($state.params.stateId)) {
          $scope.states.current = null;
        } else {
          $scope.states.current = _.find($scope.states.list, { id: $state.params.stateId });
          $scope.states.current = ModelsService.find('states', 'id', $scope.states.current.id);
        }
      }
    }

    /**
     * Method sets widget data from Model
     *
     * @private
     */
    // function defineWidgetList() {
    //   var tmpList = [];
    //   var unorderedWidgets = WidgetsService
    //       .getWidgetsFromRelatives($scope.simulation.current.relatives);

    //   if ($scope.states.current) {
    //     $scope.widgets.all = WidgetsService
    //       .getWidgetsFromRelatives($scope.simulation.current.relatives);
    //   }
    //   _.forEach($scope.widgets.all, function (all) {
    //     var found;

    //     found = _.find(unorderedWidgets, { id: all.id });


    //     if (found) {
    //       tmpList.push(found);
    //       all.active = true;
    //     } else {
    //       all.active = false;
    //     }
    //   });

    //   $scope.widgets.list = tmpList;


    //   if (
    //     $state.params.widgetId
    //     && $state.params.widgetId !== 'events'
    //     && $state.params.widgetId !== 'sbar'
    //   ) {
    //     $scope.widgets.current = _.find($scope.widgets.all, { id: $state.params.widgetId });
    //     $scope.widgets.current = ModelsService.find('widgets', 'id', $scope.widgets.current.id);
    //   }
    // }

    // Hook to send a postMessage of navigation events to authoring instead of handling
    // directly in delivery.
    $scope.$on('$stateChangeStart', function (event, toState, toParams) {
      if ($location.search().newman) {
        event.preventDefault();
        $window.top.postMessage(toParams, '*');
      } else {
        event.defaultPrevented = false;
      }
    });

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      // if not starting on the content start
      // then force UI to content start
      // unless being loaded through newman (query param)
      if (
        !$rootScope.simulation.content.initialized
        && $rootScope.simulation.content.start !== $state.params.stateId
        && !$location.search().newman
      ) {
        $state.go(
          'routes.simulation.states',
          { stateId: $rootScope.simulation.content.start, mode: null },
          { reload: true }
        );
      } else {
        $rootScope.simulation.content.initialized = true;
        defineConstants();
        defineCaseList();
        defineCurrentCase();
        defineTheme();
        defineStateList();
        // defineWidgetList();
      }
    }
    initialize();
  }
]);
